// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"314":"a8a2171f","913":"a5402851"}[chunkId] + ".chunk.js";
};